import React, { useState } from 'react';
import { FacilitiesGrid } from './FacilitiesGrid';
import { BookingCalendarView } from './BookingCalendarView';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';
import { AlertTriangle } from 'lucide-react';

export const BookingsList = () => {
  const [selectedFacilityId, setSelectedFacilityId] = useState<string | null>(null);
  const { features, isLoading } = useFeatureFlags();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-gray-600 dark:text-gray-400">Lädt...</div>
      </div>
    );
  }

  if (!features.bookingSystem) {
    return (
      <div className="rounded-md bg-yellow-50 dark:bg-yellow-900/50 p-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <AlertTriangle className="h-5 w-5 text-yellow-400" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800 dark:text-yellow-300">
              Funktion nicht verfügbar
            </h3>
            <p className="mt-2 text-sm text-yellow-700 dark:text-yellow-200">
              Das Buchungssystem ist derzeit deaktiviert. Bitte versuchen Sie es später erneut oder kontaktieren Sie einen Administrator.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white">Anlagen buchen</h2>
        {selectedFacilityId && (
          <button
            onClick={() => setSelectedFacilityId(null)}
            className="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 hover:text-gray-900 dark:hover:text-white"
          >
            ← Zurück zur Übersicht
          </button>
        )}
      </div>
      
      {!selectedFacilityId ? (
        <FacilitiesGrid onFacilitySelect={setSelectedFacilityId} />
      ) : (
        <BookingCalendarView
          facilityId={selectedFacilityId}
          onBack={() => setSelectedFacilityId(null)}
        />
      )}
    </div>
  );
};